import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import {RFValue} from 'react-native-responsive-fontsize';

import {css} from 'styled-components/native';

export const Container = styled.View`
  
`;

export const LocationList = styled.View`

`;

export const LocationContainer = styled.View`
  flex-direction: row;
  gap:${RFValue(8)}px;
`;

export const Icon = styled(Feather)`
  margin-left: ${RFValue(4)}px;
`;

export const LocationPill = styled.Pressable<{selected: boolean}>`
  padding: ${RFValue(6)}px;
  padding-left: ${RFValue(8)}px;
  border-radius: ${RFValue(8)}px;
  flex: 1;
  border-width: ${RFValue(1)}px;
  border-color: ${({theme, selected}) =>
    selected ? theme.colors.blue : theme.colors.border};
  background-color: ${({selected}) => (selected ? '#68ccde' : 'transparent')};
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const LocationPillText = styled.Text<{selected: boolean}>`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(10)}px;
  ${({selected}) =>
    selected &&
    css`
      color: ${({theme}) => theme.colors.purple_2_shadow_white};
    `}
`;

export const LocationSeparator = styled.View`
  width: ${RFValue(12)}px;
`;

export const ModalOverlay = styled.View`
  flex: 1;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
  padding: ${RFValue(20)}px;
`;

export const ModalContainer = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(16)}px;
  padding: ${RFValue(24)}px;
  align-items: center;
  width: 100%;
  max-width: ${RFValue(300)}px;
`;

export const ModalIconContainer = styled.View`
  width: ${RFValue(80)}px;
  height: ${RFValue(80)}px;
  border-radius: ${RFValue(40)}px;
  background-color: ${({theme}) => theme.colors.blue}20;
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(16)}px;
`;

export const ModalTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(8)}px;
`;

export const ModalDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  margin-bottom: ${RFValue(20)}px;
  line-height: ${RFValue(20)}px;
`;

export const ModalButtonsContainer = styled.View`
  width: 100%;
`;
